import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
import Web3 from 'web3';
import { ethers } from "ethers";
import utils from "../utils";

import LiquidityPairTruffleConf from "../truffleconf/LiquidityPair.json";
import IncentivePoolTruffleConf from "../truffleconf/IncentivePoolV3.json";
import StableSwitchAccessControlsTruffleConf from "../truffleconf/StableSwitchAccessControls.json";
import LiquidityReceiptTokenTruffleConf from "../truffleconf/LiquidityReceiptToken.json";
import Token from "../truffleconf/TokenA.json";
import Config from "../truffleconf/config.json";

export default new Vuex.Store({
    state: {
        web3Objects: null,
        depositSelection: 0,
        receiveSelection: 1,
        swapAmount: "",
        fees24Hrs: "===",
    },
    mutations: {
        setWeb3Objects(state, payload) {
            state.web3Objects = payload;
        },
    },
    methods: {

    },
    actions: {
        async bootstrap({ commit }) {
            await window.ethereum.enable();

            window.ethereum.on('networkChanged', chainId => {
                // handle the new network
                console.log(chainId);
                document.location.reload();
            })
            window.ethereum.on('chainChanged', chainId => {
                // handle the new network
                console.log(chainId);
                document.location.reload();
            })
            window.ethereum.on('accountsChanged', chainId => {
                // handle the new network
                console.log(chainId);
                document.location.reload();
            })

            /*global web3*/
            const provider = new ethers.providers.Web3Provider(web3.currentProvider);
            const signer = provider.getSigner();
            const chain = await provider.getNetwork();
            if (!chain || (chain && chain.chainId != 1 && chain.chainId != 4)) {
                let instance = Vue.$toast.open({
                    message: 'Wrong Network Selected.',
                    type: 'error',
                    position: 'top-right'
                });
                setTimeout(() => {
                    instance.dismiss();
                }, 5000)
                return;
            }

            const liquidityPairContractAddress = utils.getContractAddressFromTruffleConf(
                LiquidityPairTruffleConf,
                chain.chainId
            );
            const liquidityPairContract = new ethers.Contract(
                liquidityPairContractAddress,
                LiquidityPairTruffleConf.abi,
                signer
            );

            const incentivePoolContractAddress = await liquidityPairContract.incentivePool();

            const incentivePoolContract = new ethers.Contract(
                incentivePoolContractAddress,
                IncentivePoolTruffleConf.abi,
                signer
            );

            const liquidityReceiptContractAddress = await liquidityPairContract.liquidityReceiptToken();

            const liquidityReceiptContract = new ethers.Contract(
                liquidityReceiptContractAddress,
                LiquidityReceiptTokenTruffleConf.abi,
                signer
            );

            const accessControlsContractAddress = utils.getContractAddressFromTruffleConf(
                StableSwitchAccessControlsTruffleConf,
                chain.chainId
            );
            const accessControlsContract = new ethers.Contract(
                accessControlsContractAddress,
                StableSwitchAccessControlsTruffleConf.abi,
                signer
            );

            const accounts = await window.ethereum.send('eth_requestAccounts');
            // console.log('accounts', accounts);
            // const accounts = await provider.listAccounts();

            commit("setWeb3Objects", {
                provider,
                homesteadProvider: ethers.getDefaultProvider("homestead"),
                signer,
                chain,
                contracts: {
                    liquidityPairContract,
                    incentivePoolContract,
                    accessControlsContract,
                    liquidityReceiptContract
                },
                account: accounts.result[0],
            });
        },
        resetSwitchStore() {
            this.depositSelection = 0;
            this.receiveSelection = 1;
            this.swapAmount = "";
        },
        async loadData({ state }) {
            let canLoad = true;
            let updatedOn = localStorage.getItem('updatedOn');
            let updatedData = localStorage.getItem('updatedData');
            if (updatedOn) {
                let lastDate = new Date(updatedOn);
                lastDate.setHours(lastDate.getHours() + 1)
                if (lastDate <= new Date()) {
                    canLoad = true
                } else {
                    canLoad = false;
                }
            } else {
                canLoad = true;
            }

            if (!updatedData) {
                canLoad = true;
            }

            if (canLoad) {
                const web3 = new Web3(new Web3.providers.HttpProvider(Config.MAINNET_HTTP));
                const lpInstance = new web3.eth.Contract(Config.LP_ABI, Config.LP_CONTRACT);

                let latestBlock = await web3.eth.getBlockNumber();

                let event = await lpInstance.getPastEvents('Swap', {
                    fromBlock: Number(latestBlock) - 6400,
                    toBlock: latestBlock
                });

                try {
                    let totalFee = 0;
                    for (let i = 0; i < event.length; i++) {
                        // console.log("here", i, event[i].returnValues.feePaid)
                        totalFee = totalFee + Math.abs(event[i].returnValues.feePaid);
                    }
                    const in$ = Number(web3.utils.fromWei(totalFee.toString(), "ether")).toFixed(4);
                    localStorage.setItem('updatedOn', (new Date()).getTime());
                    localStorage.setItem('updatedData', in$);
                    state.fees24Hrs = in$;
                } catch (e) {
                    console.log("Error", e)
                }
            } else {
                let updatedData = localStorage.getItem('updatedData');
                state.fees24Hrs = updatedData;
            }
        }
    },
    modules: {
    },
    getters: {
        contracts: state => (state.web3Objects ? state.web3Objects.contracts : null),
        erc20TokenContract: (state) => (tokenAddress) => {
            return new ethers.Contract(
                tokenAddress,
                Token.abi,
                state.web3Objects.signer
            );
        },
        account: state => (state.web3Objects ? state.web3Objects.account : null),
        feesPrice: state => (state.fees24Hrs),
    }
})
